import { ReferralCustomTargetUrl } from '@pages/IntroducingBroker/Dashboard/ReferralLink/ReferralCustomTargetUrl'
import { ReferralLandingPageDropdown } from '@pages/IntroducingBroker/Dashboard/ReferralLink/ReferralLandingPageDropdown'

import { NameDto } from '@model/NameDto'
import { ReferralMaterialsUrls } from '@model/ReferralMaterialDto'

import { SetState } from '@global/types/SetState'

import { Box } from '@shared/components/Box'

interface ReferralLandingPageSelectProps {
  landingPageUrl: NameDto<string> | undefined
  setLandingPageUrl: SetState<NameDto<string> | undefined>
  shortenedReferralLink?: string
  setShortenedReferralLink: SetState<string | undefined>
  customTargetUrl: string | null
  landingPageUrlsFromCategories?: ReferralMaterialsUrls[]
  ibCode?: string
  isLoadingLpUrlsFromCategories: boolean
  isShortLinkLoading: boolean
  setCustomLandingPageUrl: SetState<string | null>
}

export const ReferralLandingPageSelect = (props: ReferralLandingPageSelectProps) => {
  return (
    <Box flex gap='x10' direction='column'>
      <ReferralLandingPageDropdown {...props} />
      <ReferralCustomTargetUrl {...props} />
    </Box>
  )
}
